import { getItemByKeyValue } from '../helpers'

export interface Options {
  optionName: string
  optionValue: string
  approved?: boolean
  message?: string
}
export interface Requests {
  fieldID: string
  fieldName: string
  newOptions: Options[]
}
export interface ChangeRequests {
  changeRequests: Requests[]
  requestDate: string
  requestID: string
  requestNote: string
  requestedBy: string
  reviewNote: null | any
  reviewedBy: null
  wasApproved: boolean
}
export interface SupportState {
  requestAnExpert: {
    requested: boolean
    success: boolean
  }
  forgotPassword: {
    requested: boolean
    success: boolean
  }
  resetPassword: {
    requested: boolean
    success: boolean
  }
  pendingRequests: ChangeRequests[]
  completedRequests: ChangeRequests[]
  dismissedRequests: ChangeRequests[]
}

export const initialState = {
  requestAnExpert: {
    requested: false,
    success: false,
  },
  forgotPassword: {
    requested: false,
    success: false,
  },
  resetPassword: {
    requested: false,
    success: false,
  },
  pendingRequests: [],
  completedRequests: [],
  dismissedRequests: [],
}

export const support = (
  state: SupportState = initialState,
  action: ReduxAction,
): SupportState => {
  switch (action.type) {
    case 'GET_UPDATE_REQUEST': {
      const {
        pendingRequests,
        completedRequests,
        dismissedRequests,
      } = action.payload
      return {
        ...state,
        pendingRequests: pendingRequests.map((req) => {
          return {
            ...req,
            changeRequests: req.changeRequests.map((item) => {
              const { newOptions } = item
              return {
                ...item,
                newOptions:
                  !newOptions || (newOptions && newOptions.length === 0)
                    ? [{ optionName: '', optionValue: '' }]
                    : newOptions,
              }
            }),
          }
        }),
        completedRequests,
        dismissedRequests,
      }
    }
    case 'SEND_UPDATE_REQUEST': {
      return {
        ...state,
      }
    }
    case 'SET_UPDATE_PENDING_REQUEST': {
      const { pendingRequests } = state
      const { requestID } = action.payload
      const pendingRequest = getItemByKeyValue(
        pendingRequests,
        'requestID',
        requestID,
      )
      // eslint-disable-next-line
      // debugger
      if (pendingRequest !== -1) {
        const updatedPendingRequest = {
          ...pendingRequest,
          ...action.payload,
        }
        const index = getItemByKeyValue(
          pendingRequests,
          'requestID',
          requestID,
          true,
        )
        pendingRequests[index] = updatedPendingRequest
      }
      return {
        ...state,
        ...pendingRequests,
      }
    }
    case 'REQUEST_AN_EXPERT':
      return {
        ...state,
        requestAnExpert: {
          requested: true,
          success: action.payload,
        },
      }
    case 'RESET_REQUEST_AN_EXPERT':
      return {
        ...state,
        requestAnExpert: {
          requested: false,
          success: false,
        },
      }
    case 'REQUEST_PASSWORD_RESET':
      return {
        ...state,
        forgotPassword: {
          requested: true,
          success: action.payload,
        },
      }
    case 'RESET_PASSWORD':
      return {
        ...state,
        resetPassword: {
          requested: true,
          success: action.payload,
        },
      }
    case 'REQUEST_PASSWORD_RESET_STATE':
      return {
        ...state,
        forgotPassword: {
          requested: false,
          success: false,
        },
      }
    default:
      return state
  }
}
